import GroupByList from "./Base/GroupByList";

class OrderDetail {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  tableConfig = {
    cols: [
      {
        title: "名称",
        field: "ProductName",
        default: "无",
        style: {
          width: "16%",
          center: "",
        },
        class: ["ellipsis"],
      },
      {
        title: "品牌",
        field: "BrandName",
        default: "无",
        style: {
          width: "16%",
        },
        class: ["ellipsis"],
      },
      {
        title: "型号",
        field: "Model",
        default: "无",
        style: {
          width: "16%",
        },
        class: ["ellipsis"],
      },
      {
        title: "数量",
        field: "CountNum",
        default: "0",
        style: {
          width: "16%",
          "text-align": "right",
        },
        class: ["ellipsis"],
      },
      {
        title: "单价",
        field: "Price",
        default: "0.00",
        style: {
          width: "16%",
          "text-align": "right",
        },
        class: ["ellipsis"],
      },
      {
        title: "金额",
        field: "Amount",
        default: "0.00",
        style: {
          width: "16%",
          "text-align": "right",
        },
        class: ["ellipsis", "red"],
      },
    ],
  };

  tables = [];

  constructor() {}

  initTablesGroupBy({ list, field }) {
    console.log(list, field);
    let groupByList = new GroupByList({ list });
    let groupByResult = groupByList.groupBy(field);

    this.tables = groupByResult.map((it) => {
      return Object.assign(
        {
          title: it.name,
          rows: it.list,
        },
        this.tableConfig
      );
    });
  }
}
export default new OrderDetail();
